import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';
import './WarningMessage.scss';

const WarningMessage = ({ message }) => (
  <div className="swimming-warning">
    <div className="exclamation-mark">
      <FontAwesomeIcon icon={faExclamation} size="lg" />
    </div>
    <div className="warning-message">{message}</div>
  </div>
);

WarningMessage.propTypes = {
  message: PropTypes.string.isRequired,
};

export default WarningMessage;
